// @ts-nocheck
/* eslint-disable */
export const trackerIcon = {
        data: `<svg
    class="management-nav-icon"
    viewBox="0 0 100 100"
    fill="none">
 <path
        class="lower-hexagon"
        d="M48.0833 2.83864C49.2694 2.15388 50.7306 2.15388 51.9167 2.83864L89.8846 24.7594C91.0706 25.4442 91.8013 26.7097 91.8013 28.0792V71.9208C91.8013 73.2903 91.0706 74.5558 89.8846 75.2406L51.9167 97.1614C50.7306 97.8461 49.2694 97.8461 48.0833 97.1614L10.1154 75.2406C8.92936 74.5558 8.19873 73.2903 8.19873 71.9208V28.0792C8.19873 26.7097 8.92936 25.4442 10.1154 24.7594L48.0833 2.83864Z"
        stroke-width="3" />
    <g style="mix-blend-mode: soft-light">
        <path
            class="upper-hexagon-shade"
            d="M50 8L87 29.7166V48.2875C87 48.2875 76.7767 57 50 57C24.6328 57 13 48.2875 13 48.2875V30L50 8Z" />
        <path
            d="M14 30.5688L50.0033 9.16146L86 30.2892V47.7954C85.9763 47.8127 85.9514 47.8308 85.9252 47.8495C85.6165 48.0712 85.1369 48.3955 84.474 48.7888C83.1485 49.5752 81.0886 50.6379 78.1951 51.7056C72.4099 53.8403 63.2778 56 50 56C37.4335 56 28.2975 53.8424 22.3246 51.7024C19.3372 50.632 17.1385 49.565 15.6954 48.7724C14.9739 48.376 14.4412 48.0482 14.0932 47.8227C14.0605 47.8015 14.0294 47.7812 14 47.7618V30.5688Z"
            stroke="black"
            stroke-opacity="0.01"
            stroke-width="2" />
    </g>

    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M48.9131 34.36C48.0635 34.5034 47.2731 34.9103 46.658 35.531L37.2 45.0786C37.0718 45.2069 37 45.3821 37 45.5628V69.3103C37 69.691 37.309 70 37.6897 70H61.5159C61.8966 70 62.2056 69.691 62.2056 69.3103V45.5628C62.2056 45.3821 62.1338 45.2069 62.0056 45.0786C62.0056 45.0786 56.0359 39.051 52.5476 35.531C51.9325 34.9103 51.1421 34.5034 50.2924 34.36V30.6897C50.2924 30.309 49.9835 30 49.6028 30C49.2221 30 48.9131 30.309 48.9131 30.6897V34.36ZM50.2924 35.7697V40.5972C51.5476 40.9062 52.48 42.04 52.48 43.3903C52.48 44.9779 51.1904 46.2662 49.6028 46.2662C48.0152 46.2662 46.7269 44.9779 46.7269 43.3903C46.7269 42.04 47.658 40.9062 48.9131 40.5972V35.7697C48.4345 35.8924 47.9918 36.1434 47.6373 36.5007L38.3793 45.8469V68.6207H60.8263V45.8469L51.5683 36.5007C51.2138 36.1434 50.7724 35.8924 50.2924 35.7697ZM48.9131 50.531C46.8193 50.651 45.1931 52.24 45.1931 54.1352V54.1379C45.1931 56.091 46.9338 57.7159 49.1283 57.7159H50.1559C50.8221 57.7159 51.4649 57.9476 51.9366 58.3669C52.378 58.76 52.6332 59.2897 52.6332 59.8455V59.8497C52.6332 60.9724 51.5738 61.84 50.3132 61.84H49.1449C48.4525 61.84 47.7862 61.6 47.2966 61.1641C47.1118 60.9986 46.9573 60.8097 46.84 60.6055C46.6497 60.2759 46.2277 60.1628 45.898 60.3517C45.5683 60.5421 45.4538 60.9641 45.6442 61.2938C45.8331 61.6234 46.0801 61.9269 46.3794 62.1945C47.0594 62.7986 47.96 63.1614 48.9131 63.2124V64.1352C48.9131 64.5159 49.2221 64.8248 49.6028 64.8248C49.9835 64.8248 50.2924 64.5159 50.2924 64.1352V63.2193H50.3132C52.3766 63.2193 54.0125 61.6869 54.0125 59.8497V59.8455C54.0125 58.9062 53.6 58.0014 52.8538 57.3366C52.138 56.6993 51.1683 56.3366 50.1559 56.3366H49.1283C47.7366 56.3366 46.5724 55.3752 46.5724 54.1379V54.1352C46.5724 52.88 47.7531 51.9034 49.1642 51.9034H49.869C51.0304 51.9034 52.0359 52.52 52.4455 53.4234C52.6028 53.7697 53.011 53.9241 53.3573 53.7669C53.7048 53.6097 53.858 53.2 53.7007 52.8538C53.138 51.611 51.8469 50.6869 50.2924 50.5434V49.6083C50.2924 49.2276 49.9835 48.9186 49.6028 48.9186C49.2221 48.9186 48.9131 49.2276 48.9131 49.6083V50.531ZM48.9131 42.0607C48.4331 42.3103 48.1062 42.8124 48.1062 43.3903C48.1062 44.2166 48.7766 44.8869 49.6028 44.8869C50.429 44.8869 51.1007 44.2166 51.1007 43.3903C51.1007 42.8124 50.7724 42.3103 50.2924 42.0607V42.3724C50.2924 42.7531 49.9835 43.0621 49.6028 43.0621C49.2221 43.0621 48.9131 42.7531 48.9131 42.3724V42.0607Z"
        fill="var(--icon-text)"
        stroke="var(--icon-text)"
        stroke-width="0.75" />


      <defs>
        <linearGradient
            id="paint0_linear_dark"
            x1="48.4375"
            y1="3.125"
            x2="73.4375"
            y2="87.5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#4FC8EC" />
            <stop
                offset="1"
                stop-color="#2D3792" />
        </linearGradient>
        <linearGradient
            id="paint1_linear_dark"
            x1="50"
            y1="100"
            x2="50"
            y2="7.11531e-07"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#2D3792" />
            <stop
                offset="1"
                stop-color="#4FC8EC" />
        </linearGradient>
        <linearGradient
            id="paint2_linear_dark"
            x1="48.5908"
            y1="7.99662"
            x2="60.3796"
            y2="64.1636"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#ADAFB1" />
            <stop
                offset="1"
                stop-color="#CCCDCF" />
        </linearGradient>

        <linearGradient
            id="paint0_linear_light"
            x1="48.4375"
            y1="3.125"
            x2="73.4375"
            y2="87.5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#1D53A4" />
            <stop
                offset="1"
                stop-color="#1C3664" />
        </linearGradient>
        <linearGradient
            id="paint1_linear_light"
            x1="50"
            y1="100"
            x2="50"
            y2="7.11531e-07"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#1C3664" />
            <stop
                offset="1"
                stop-color="#1D53A4" />
        </linearGradient>
        <linearGradient
            id="paint2_linear_light"
            x1="48.5908"
            y1="7.99662"
            x2="60.3796"
            y2="64.1636"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#ADAFB1" />
            <stop
                offset="1"
                stop-color="#CCCDCF" />
        </linearGradient>
    </defs>
</svg>
`,
name: 'tracker' as const
};